module.exports = __webpack_public_path__ + "img/about-us-banner.13c44f80.jpg";